module.exports = __webpack_public_path__ + "static/img/ArteMasBanner.b69b057.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ArteMasBanner.gif
// module id = J/d/
// module chunks = 1